import React, { useEffect, useRef, useState } from "react";
import finishIcon from "../../../Images/finishIcon.svg";
import VTEXmsgIcon from "../../../Images/VTEXmsgIcon.svg";
import { useSession } from "../../../authentications/SessionContext";
import { OTPtime } from "../../../Components/StyledComponents/VerifyEmailStyle";
import { useNavigate } from "react-router-dom";
import "./VerifyEmail.css";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { Helmet } from "react-helmet-async";
import OTPInput from "react-otp-input";
import { useFormikContext } from "formik";
import AuthTopbar from "../../../Components/AuthTopbar/AuthTopbar";
import { primaryColor } from "../../../utilities/colors";
import { enqueueSnackbar } from "notistack";

const VerifyEmail = ({
  mode,
  handleOTP,
  handleResendOTP,
  handleSendOtp,
  handleVerifyOtp,
  isOTPLoading,
}) => {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;
  const { values } = useFormikContext() || { values: {} };
  const OTPCounter = useRef();
  const intervalIdRef = useRef(null);
  const [resendEmail, setResendEmail] = useState(false);
  const [resetTimer, setResetTimer] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const navigate = useNavigate();
  const { language, translations } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    console.log("Component Mounted - Timer Started");
    intervalIdRef.current = setInterval(handleOTPTimer, 1000);
    return () => {
      console.log("Component Unmounted - Timer Cleared");
      clearInterval(intervalIdRef.current);
    };
  }, [resetTimer]);

  const handleOTPTimer = () => {
    if (OTPCounter?.current?.innerText) {
      let [min, sec] = OTPCounter.current.innerText?.split(":");
      if (Number(sec) === 0) {
        if (Number(min) === 0) {
          clearInterval(intervalIdRef.current);
          setResendEmail(true);
          return;
        }
        min = Number(min) - 1;
        sec = 59;
      } else {
        sec = Number(sec) - 1;
      }
      OTPCounter.current.innerText = `${min}:${sec}`;
    }
  };

  const handleVerify = () => {
    console.log("OTP Entered:", verificationCode);
    if (verificationCode.length !== 6) {
      enqueueSnackbar("Please enter a valid 6-digit OTP.", {
        variant: "warning",
      });
      return;
    }
    if (mode === "verify-email") {
      handleOTP(verificationCode);
    } else if (mode === "2fa") {
      handleVerifyOtp(verificationCode);
    }
  };

  const handleResend = () => {
    console.log("Resending OTP...");
    if (OTPCounter.current) {
      OTPCounter.current.innerText = "2:00";
    }
    clearInterval(intervalIdRef.current);
    intervalIdRef.current = setInterval(handleOTPTimer, 1000);
    setResetTimer(!resetTimer);
    setResendEmail(false);

    if (mode === "verify-email") {
      handleResendOTP(values);
    } else if (mode === "2fa") {
      handleSendOtp(values);
    }
  };

  return (
    <div className="screen_split">
      <Helmet>
        <title>
          {mode === "verify-email"
            ? "2-step Verification"
            : "2-Factor Authentication"}{" "}
          | Seller Portal | Xhawi
        </title>
      </Helmet>

      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ padding: "33px" }}
      >
        <div className="w-100">
          <AuthTopbar className={"px-0 py-0"} />
        </div>

        <img
          src={isVTEX ? VTEXmsgIcon : finishIcon}
          width={100}
          height={100}
          className="mb-3"
          alt="Verification Icon"
        />
        <h3 className="fw-bold otp_heading">
          {mode === "verify-email"
            ? "2-step Verification"
            : "2-Factor Authentication"}
        </h3>
        <div className="login_text text-center">
          {
            t[
              "We sent a verification code to your email. Enter the code from the email in the field below."
            ]
          }
        </div>

        {/* <div className="verification-code-container"> */}
        {/* {verificationCode.map((digit, index) => (
            <input
              key={index}
              type="text"
              className="verification-code-input"
              maxLength={1}
              value={digit}
              onChange={(e) =>
                handleVerificationCodeChange(index, e.target.value)
              }
            />
          ))} */}
        <OTPInput
          value={verificationCode}
          onChange={(code) => {
            console.log("Updated OTP:", code);
            setVerificationCode(code);
          }}
          containerStyle={{ gap: "0.5rem" }}
          numInputs={6}
          // renderSeparator={<span>-</span>}
          renderInput={(props) => (
            <input {...props} className="verification-code-input mt-3 me-0" />
          )}
        />

        <button
          className="btn-lg btn-sm-md btn-xs-sm mt-4"
          type="button"
          onClick={handleVerify}
          disabled={isOTPLoading}
          style={{
            backgroundColor: isVTEX ? "#000000" : primaryColor.primary,
            border: isVTEX
              ? `1px solid #000000`
              : `1px solid ${primaryColor.primary}`,
            color: isVTEX ? primaryColor.primary : "#fff",
            borderRadius: "14px",
            fontFamily: "Comfortaa",
            fontSize: "1rem",
          }}
        >
          {[
            mode === "2fa"
              ? "Verify OTP"
              : isOTPLoading
              ? "Verifying..."
              : "Verify my Account",
          ]}
        </button>

        <div className="last_sec_email">
          OTP will expire in{" "}
          <OTPtime ref={OTPCounter} className="ps-2 ">
            2:00
          </OTPtime>
        </div>
        {mode == "verify_email" && (
          <div className="last_sec_email">
            {t["Haven't received it?"]}
            <button
              disabled={!resendEmail}
              onClick={handleResend}
              style={{
                color: isVTEX ? primaryColor.primary : "#fff",
                backgroundColor: isVTEX ? "#000000" : primaryColor.primary,
                borderRadius: "14px",
              }}
              className={`resend_span border-0 ${
                resendEmail === false ? "disabled" : ""
              }`}
            >
              {t["Resend a new code"]}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
